import {
  FINISH_LOADING_APPLICATION,
  LOAD_BUSINESS_ACTIVITIES, RETRIEVE_DOMAIN_DETAILS, RLTD_ACC_NOT_AVL,
  START_LOADING_APPLICATION,
} from "../action";
import { getBusinessActivities } from "../api/api";

export const loadBusinessActivities = (userId) => async (dispatch) => {
  dispatch({ type: START_LOADING_APPLICATION });
  try {
    const data = await getBusinessActivities(userId);
    if(data !== undefined) {
      dispatch({ type: LOAD_BUSINESS_ACTIVITIES, payload: data });
    }else{
      dispatch({ type: RLTD_ACC_NOT_AVL });
      dispatch({ type: FINISH_LOADING_APPLICATION });
    }
  } catch (error) {
    console.error("Error loading business activities:", error);
    dispatch({ type: RLTD_ACC_NOT_AVL });
    dispatch({ type: FINISH_LOADING_APPLICATION });
  } finally {
    dispatch({ type: FINISH_LOADING_APPLICATION });
  }
};
